import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { resetPage } from "../../redux/slices/containerMovies.js";
import { resetSeriesPage } from "../../redux/slices/containerSeries.js";
import { fetchCategories } from '../../redux/thunks/categories.js'



const Categories = (props) => {

    const [categories, setCategories] = useState([])
    const categoriesRedux = useSelector(state => state.categories.data)
    const dispatch = useDispatch()
    const [optionSelected, setOptionSelected] = useState([])

    useEffect(() => {
        categoriesRedux && categoriesRedux.length !== 0
            ? setCategories([null, ...categoriesRedux]) //
            : dispatch(fetchCategories())
    }, [categoriesRedux, dispatch, setCategories])

    const handlingFilter = (e) => {
        if (e.target.name === 'filter') {
            dispatch(resetPage())
            dispatch(resetSeriesPage())
            props.onClick(null, optionSelected)
        } else {
            dispatch(resetPage())
            dispatch(resetSeriesPage())
            props.onClick(null, null)
            setCategories([null, ...categoriesRedux])
            setOptionSelected([])
        }
    }

    const handlingSelection = (e) => {
        if (!!e.target.value) {
            setOptionSelected([...optionSelected, e.target.value])
            setCategories(categories.filter(c => c !== e.target.value))
        }
    }

    const handlingOptionDelete = (i) => {
        setCategories([optionSelected[i], ...categories])
        setOptionSelected(optionSelected.filter((c, ind) => ind !== i))
    }

    return (
        <div className="fl-cl categories__mainContainer">
            <div className="fl-rw categories__container">
                <select defaultValue="Categorias / Generos" name="option" onChange={handlingSelection}>
                    <option defaultValue="" disabled >Categorias / Generos</option>
                    {
                        !!categories.length && categories.map((c, i) => {
                            return (<option value={c} key={c}>{c}</option>)
                        })
                    }
                </select>
                {
                    props.type === 'form'
                        ? undefined
                        : <div>
                            <button className="button-left" name='filter' onClick={handlingFilter}>Filtrar</button>
                            <button className="button-right" name='reset' onClick={handlingFilter}>Reset</button>
                        </div>
                }
            </div>
            {
                !!optionSelected.length && <div className="categories__container__optionSelected">
                    {
                        optionSelected.map((opt, i) => {
                            return (
                                <div className="categories__optionSelected" key={i + opt}>{opt} <span style={{ "cursor": "pointer" }} onClick={() => handlingOptionDelete(i)}>| x</span></div>
                            )
                        })
                    }
                </div>
            }
        </div>
    )
}

export default Categories